import { History } from "history";
import deburr from "lodash/deburr";
import kebabCase from "lodash/kebabCase";

import { AppToaster } from "@components";
import { DEFAULT_POLICY_TEXT } from "@constants";
import { OrgData } from "@types";

import { Action } from "@pages/settings/types";

import { fetchPolicy, savePolicy } from "../api";
import { PolicyRule } from "../types";

export const onCreatePolicy =
  (
    org: OrgData,
    history: History,
    refreshPolicies: () => void,
    rules: PolicyRule[] = [],
    notifications: Action[] = [],
    pr_comments: boolean = false,
    blocking: boolean = false
  ) =>
  async () => {
    let policyName = prompt("New Policy Name:");
    if (policyName === null) return;
    let newSlug = kebabCase(deburr(policyName!.toLowerCase()));
    let overwrittenPolicy;
    try {
      overwrittenPolicy = (await fetchPolicy(org!.id, newSlug)).policy;
    } catch (err) {
      // Do nothing - this is actually our expected case
      // TODO: Change to using POST method
    }
    if (overwrittenPolicy) {
      AppToaster.show({
        message: `Policy "${overwrittenPolicy.name}" already exists`,
        intent: "danger",
      });
      return;
    }
    savePolicy(org!.id, {
      name: policyName,
      slug: newSlug,
      repos: [],
      rules: rules,
      is_default: false,
      notifications: notifications,
      pr_comments: pr_comments,
      blocking: blocking,
      description: DEFAULT_POLICY_TEXT,
      overrides: [],
    })
      .then(() => {
        AppToaster.show({
          message: `Created policy '${policyName}'`,
          intent: "success",
        });
        // View newly created policy
        history.push(`/manage/policies/${newSlug}`);
        refreshPolicies();
      })
      .catch((err) => {
        AppToaster.show({
          message: `Failed to create policy: ${err}`,
          intent: "danger",
        });
        return;
      });
  };
